import { useRef, useState } from "react";

import { usePromiseStatus } from "../../../Lib/UI/Hooks/usePromiseStatus";
import { IPlaceSearchResult, IPlaceSearchService } from "../placeSearchTypes";


export interface SearchPlacesListProps {
    placeSearchService: IPlaceSearchService;
    onView: (item: IPlaceSearchResult) => void;
    biasBounds?: L.LatLngBounds | null;
    maxResults?: number;
}

const useSearchPlacesList = (props: SearchPlacesListProps) => {

    const searchTermsMinLength: number = 3;

    const searchStatus = usePromiseStatus<IPlaceSearchResult[]>();
    const [results, setResults] = useState<IPlaceSearchResult[] | null>(null);
    const [lastTerms, setLastTerms] = useState<string>('');
    const abort = useRef<AbortController | null>(null);

    const startSearch = (terms: string) => {

        if (!terms && terms.length === 0)
            return;

        setLastTerms(terms);

        abort.current?.abort(); //Abort existing request (if any)
        abort.current = new AbortController();

        const downloadPromise = props.placeSearchService.search(terms, props.biasBounds, props.maxResults, abort.current);
        searchStatus.setPromise(downloadPromise);
        downloadPromise.then(setResults);

    }

    return {
        searchTermsMinLength,
        lastTerms,
        startSearch,
        searchStatus,
        results, hasResults: !!results
    };

};

export default useSearchPlacesList;